import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    private readonly sanitizer = inject(DomSanitizer);

    transform(value: string): string {
        return this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
    }
}
